"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _constant = require("./constant");

var _Icons = require("./Icons");

var _Loader = require("./Loader");

var _forgotPass = _interopRequireDefault(require("./forgot-pass"));

var _formFiledModule = _interopRequireDefault(require("../styles/form-filed.module.css"));

var _baseModule = _interopRequireDefault(require("../styles/base.module.css"));

var _loginModule = _interopRequireDefault(require("../styles/login.module.css"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var EmailLogin =
/*#__PURE__*/
function (_React$Component) {
  _inherits(EmailLogin, _React$Component);

  function EmailLogin(props) {
    var _this;

    _classCallCheck(this, EmailLogin);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EmailLogin).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "forgotPass", function () {
      _this.setState(function (prev) {
        return {
          forgotPass: !prev.forgotPass
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "login", function (e) {
      var onSuccess = _this.props.onSuccess;
      e.preventDefault();
      var formData = new FormData(e.target);

      _this.setState({
        loading: true,
        error: false
      });

      fetch("".concat(_constant.API_ROOT, "login.php"), {
        credentials: 'same-origin',
        method: 'POST',
        body: formData
      }).then(_constant.checkStatus).then(_constant.parseJSON).then(function (data) {
        if (data.status) {
          onSuccess(data.payload);
        } else {
          _this.setState({
            error: true,
            loading: false
          });
        }
      }).catch(function (err) {
        return console.log(err);
      });
    });

    _this.state = {
      loading: false,
      error: false,
      forgotPass: false
    };
    return _this;
  }

  _createClass(EmailLogin, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          forgotPass = _this$state.forgotPass,
          error = _this$state.error,
          loading = _this$state.loading;
      var switchMode = this.props.switchMode;

      if (forgotPass) {
        return _react.default.createElement(_forgotPass.default, {
          back: this.forgotPass
        });
      }

      return _react.default.createElement("form", {
        className: _baseModule.default.container,
        onSubmit: this.login
      }, error ? _react.default.createElement("span", {
        className: _loginModule.default.errorBlock
      }, _react.default.createElement(_Icons.CrossInsideCircle, {
        width: "1rem"
      }), _react.default.createElement("span", null, "Incorrect information. Please try again or choose another log in method")) : '', _react.default.createElement("input", {
        type: "email",
        name: "user",
        className: "".concat(_formFiledModule.default.input, " ").concat(_baseModule.default.rightEmailIcon),
        placeholder: "Email address",
        required: true
      }), _react.default.createElement("input", {
        type: "password",
        name: "password",
        className: "".concat(_formFiledModule.default.input, " ").concat(_baseModule.default.rightLockIcon),
        placeholder: "Password",
        required: true
      }), _react.default.createElement("label", {
        className: _formFiledModule.default.checkbox
      }, _react.default.createElement("input", {
        type: "checkbox",
        name: "remember_me"
      }), _react.default.createElement("div", null, _react.default.createElement("span", null, _react.default.createElement("span", null, _react.default.createElement(_Icons.TickMark, {
        width: "0.5rem"
      }))), _react.default.createElement("span", null, "Remember me"))), _react.default.createElement("div", {
        className: _loginModule.default.forgotPass,
        onClick: this.forgotPass
      }, "Forgot password?"), _react.default.createElement("button", {
        type: "submit",
        className: "".concat(_formFiledModule.default.button, " ").concat(_formFiledModule.default.primary, " ").concat(_formFiledModule.default.block),
        disabled: loading
      }, loading ? _react.default.createElement(_Loader.ButtonLoader, null) : 'Log in'), _react.default.createElement("div", {
        onClick: function onClick(e) {
          switchMode(_constant.OTP_LOGIN_MODE);
        },
        className: "".concat(_formFiledModule.default.button, " ").concat(_formFiledModule.default.block)
      }, "Log in with OTP"));
    }
  }]);

  return EmailLogin;
}(_react.default.Component);

var _default = EmailLogin;
exports.default = _default;